import {Component, OnInit} from '@angular/core';
import {FiltersComponent} from '@abstract/filters.component';
import {FormBuilder} from '@angular/forms';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {ConclusionPagesService} from '../../services/conclusion-pages/conclusion-pages.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-conclusion-list-filters-panel',
    templateUrl: './conclusion-list-filters-panel.component.html',
    styleUrls: ['./conclusion-list-filters-panel.component.scss']
})
export class ConclusionListFiltersPanelComponent extends FiltersComponent implements OnInit {

    public blankStatusValues: SelectValueInterface[] = [
        {id: '', title: 'Оформлено'},
        {id: '1', title: 'Черновик'},
    ];

    public statuses: SelectValueInterface[] = [];
    public methods: SelectValueInterface[] = [];
    public technicalDevices: SelectValueInterface[] = [
        {id: '', title: 'Все ТУ'}
    ];
    public workingObjects: SelectValueInterface[] = [
        {id: '', title: 'Все объекты'}
    ];

    form = this.fb.group({
        conclusion_number: [''],
        conclusion_date_from: [''],
        conclusion_date_to: [''],
        tc_im_method_id: [''],
        control_order_number: [''],
        working_object_id: [''],
        technical_device_id: [''],
        conclusion_status_type_id: [''],
        wo_org_customer: [''],
        conclusion_is_blank: [''],
    });

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        pagingService: ConclusionPagesService,
    ) {
        super(pagingService);
    }

    ngOnInit() {
        super.ngOnInit();
        const {
            industryMethodsSelectValues,
            workingObjectSelectValues,
            conclusionStatusSelectValues,
            technicalDeviceSelectValues
        } = this.route.snapshot.data;

        this.statuses = conclusionStatusSelectValues || [];
        this.methods = industryMethodsSelectValues || [];
        this.technicalDevices = this.technicalDevices.concat(technicalDeviceSelectValues || []);
        this.workingObjects = this.workingObjects.concat(workingObjectSelectValues || []);
    }
}
